import SiteHeader from "@/pages/home/components/SiteHeader";
import HeroSection from "@/pages/home/components/HeroSection";
import RiskTicker from "@/pages/home/components/RiskTicker";
import EndorsementRanking from "@/pages/home/components/EndorsementRanking";
import CaseGrid from "@/pages/home/components/CaseGrid";
import TerminationTimeline from "@/pages/home/components/TerminationTimeline";
import CrisisTrend from "@/pages/home/components/CrisisTrend";
import MonitorMethod from "@/pages/home/components/MonitorMethod";
import SubscribeCta from "@/pages/home/components/SubscribeCta";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1">
        <HeroSection />
        <RiskTicker />
        <EndorsementRanking />
        <CaseGrid />
        <TerminationTimeline />
        <CrisisTrend />
        <MonitorMethod />
        <SubscribeCta />
      </main>
      <SiteFooter />
    </div>
  );
}